<template>
  <ReassuranceItem>
    <template #icon>
      <IconHeadset />
    </template>
    <template #content>
      <div class="flex flex-col">
        <span class="body-2">
          {{ i18n(translations.customerSupport) }}
        </span>
      </div>
    </template>
  </ReassuranceItem>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconHeadset } from '@ds/icons/IconHeadset'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemCustomerSupport.translations'

const i18n = useI18n()
</script>
